import { Web3dTool } from '@trimble/web3d-providers';
import { SimpleMeasurementCapabilityBase } from './base-simple-measurement-capability';

export class LineMeasurementCapability extends SimpleMeasurementCapabilityBase {
  protected measurementType: Web3dTool = Web3dTool.LineMeasurement;
}
